import { Empty } from "antd";

export default function ItemBlog({ blog }) {
  if (!blog?.length) return <Empty />;

  return (
    <div className="cyk-blog-grid">
      {blog.slice(0, 8).map((item, index) => (
        <a
          href={`/blog/${item?.blog_slug}`}
          className="cyk-blog-card"
          key={item?.blog_slug || index}
        >
          <img
            src={item?.blog_image}
            alt={item?.blog_name}
            loading="lazy"
          />

          <div>
            <h3>{item?.blog_name}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html: item?.blog_description || ""
              }}
            />
          </div>
        </a>
      ))}
    </div>
  );
}
